export const TEST_USER_AGENT_SUFFIX = "LowAngleTest";
export const NIVA_USER_AGENT_ID_BETA = "AFTGAZL";
export const NIVA_USER_AGENT_ID_GA = "AFTGAZLTC";

export enum UserAgentDeviceType {
    MOBILE = "Mobile",
    TABLET = "Tablet",
    DESKTOP = "Desktop",
    SMARTTV = "SmartTv",
    WEARABLE = "Wearable",
}
